import { useEffect, useState } from "react";

/* Slots come from the validated categorical order (blue, orange, aqua,
 * yellow); the ageing ramp is a single-hue ordinal scale. Both sets pass the
 * CVD and lightness checks in light and dark mode. Keep in sync with the
 * --dash-* tokens in Admin.css. */
const PALETTES = {
  light: {
    sales: "#2a78d6",
    pending: "#eb6834",
    collection: "#1baf7a",
    volume: "#eda100",
    grid: "#eef0f4",
    axis: "#868d9c",
    surface: "#ffffff",
    ageing: ["#86b6ef", "#5598e7", "#2a78d6", "#1c5cab"],
    brand: "#2a2962",
  },
  dark: {
    sales: "#3987e5",
    pending: "#d95926",
    collection: "#199e70",
    volume: "#c98500",
    grid: "#2a2a27",
    axis: "#8f8e85",
    surface: "#1f1f1e",
    ageing: ["#86b6ef", "#5598e7", "#3987e5", "#184f95"],
    // Brand navy disappears on the dark surface; this lighter tint keeps its hue.
    brand: "#8f8de0",
  },
};

const currentTheme = () => document.documentElement.getAttribute("data-theme") || "light";

/** Chart colours for the active theme; follows <html data-theme> changes. */
export const usePalette = () => {
  const [theme, setTheme] = useState(currentTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(currentTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => observer.disconnect();
  }, []);

  return PALETTES[theme] || PALETTES.light;
};
